import AttachmentDataProviderScope from 'owa-service/lib/contract/AttachmentDataProviderScope';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import AttachmentItemsFilterBy from 'owa-service/lib/contract/AttachmentItemsFilterBy';
export default {
    FPShowFilePicker: {
        name: 'FPShowFilePicker',
    },
    // This is used to store an action datapoint with customData, so the customData parameters must match the parameters of the action it is tracking.
    FPGetItems: {
        name: 'FPGetItems',
        customData: (
            providerType: AttachmentDataProviderType,
            providerId: any,
            offset: any,
            filterBy: AttachmentItemsFilterBy,
            scope: AttachmentDataProviderScope,
            fileProviderEndpointUrl?: any,
            folderId?: any,
            location?: any,
            pagingMetadata?: any,
            sort?: any
        ) => [providerType, scope.__type],
    },
    FPSearchItems: {
        name: 'FPSearchItems',
        customData: (
            fileProviderType: AttachmentDataProviderType,
            fileProviderId: string,
            searchQuery: string,
            offset?: number,
            folderId?: string,
            location?: string,
            pagingMetadata?: any,
            sort?: any
        ) => [fileProviderType],
    },
};
